import { render } from "./TextAreaAutoGrow.vue?vue&type=template&id=6a136946&ts=true"
import script from "./TextAreaAutoGrow.vue?vue&type=script&lang=ts"
export * from "./TextAreaAutoGrow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__